module.exports = __webpack_public_path__ + "static/media/btgpactual-min.649aeb2c.png";